import { BreadcrumbsStyled } from './styles'
import { Icon, TextButton } from 'components'
import { useContext } from 'react'
import { DataBreadcrumb } from 'store/BreadcrumbContext/Breadcrumb'
import { addIndexToRemove, mountBreadcrumb } from 'commons/customHooks/useBreadcrumbs'
import { theme } from 'styles/theme/hav-theme'

export type Route = {
  path: string
  label: string
  active?: boolean
}

export const Breadcrumb: React.FC = () => {
  const breadcrumbContext = useContext(DataBreadcrumb)
  const routes = mountBreadcrumb(breadcrumbContext.items)
  const abbreviate = routes.length > 4

  return routes.length >= 1 ? (
    <BreadcrumbsStyled
      id="BreadcrumbRoute"
      separator={
        <Icon icon="chevron-right" color={theme.colors.neutral.light} size="16" />
      }
      data-testid="breadcrumb"
    >
      {routes.crumbs.map((route, index) => {
        if (abbreviate && index > 1 && index < routes.length - 2) return
        if (abbreviate && index === routes.length - 2)
          return (
            <TextButton
              key={`text-button-${index}`}
              url={route.path}
              onClick={(event) => addIndexToRemove(event.target, breadcrumbContext)}
            >
              ...
            </TextButton>
          )
        return (
          <div
            key={`external-div-${index}`}
            onClick={(event) => addIndexToRemove(event.target, breadcrumbContext)}
            data-index={index}
          >
            {route.active ? (
              <span key={`span-${index}`} id="actual-route" data-test={0}>
                {route.label}
              </span>
            ) : (
              <TextButton key={`text-button-${index}`} url={route.path}>
                {route.label.toLocaleLowerCase() === 'home' ? 'Início' : route.label}
              </TextButton>
            )}
          </div>
        )
      })}
    </BreadcrumbsStyled>
  ) : (
    <></>
  )
}
